
function HomeHeader() {
  return (
    <div className="flex flex-col h-[50vh] px-6">
      <h1 className='text-crimson mt-20 ml-20'>
        queenbeanbaq
      </h1>
      <p className="text-crimson ml-80">
        a gallery of minecraft builds
      </p>
    </div>
  );
}

export default HomeHeader;
